import api from './api';

export const adminApi = {
  // Stats
  getStats: ()                    => api.get('/admin/stats'),

  // Users
  getUsers: (params = {})         => api.get('/admin/users', { params }),
  getUser: (id)                   => api.get(`/admin/users/${id}`),
  deleteUser: (id)                => api.delete(`/admin/users/${id}`),

  // Programs
  getPrograms: ()                 => api.get('/admin/programs'),
  getProgram: (id)                => api.get(`/admin/programs/${id}`),
  createProgram: (data)           => api.post('/admin/programs', data),
  updateProgram: (id, data)       => api.put(`/admin/programs/${id}`, data),
  deleteProgram: (id)             => api.delete(`/admin/programs/${id}`),

  // News
  getNews: ()                     => api.get('/admin/news'),
  getNewsItem: (id)               => api.get(`/admin/news/${id}`),
  createNews: (data)              => api.post('/admin/news', data),
  updateNews: (id, data)          => api.put(`/admin/news/${id}`, data),
  deleteNews: (id)                => api.delete(`/admin/news/${id}`),
};

export default adminApi;
